import { render } from "./ChallengeModal.vue?vue&type=template&id=d0e896b4&scoped=true"
import script from "./ChallengeModal.vue?vue&type=script&lang=js"
export * from "./ChallengeModal.vue?vue&type=script&lang=js"

import "./ChallengeModal.vue?vue&type=style&index=0&id=d0e896b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e896b4"]])

export default __exports__